module.exports = __webpack_public_path__ + "static/media/cases_ilustracoes_jordan_01.1e4cafb8.jpg";